import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Post-specific JS
import { createComputerClassGraph } from './posts/xerox-parc/computer-class-graph.js'

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.dark-mode-toggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      let theme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    });
  }

  // Make images and videos inside figures open in new tab when clicked
  const figureMedia = document.querySelectorAll('figure img');
  figureMedia.forEach(media => {
    media.style.cursor = 'pointer';
    media.addEventListener('click', (e) => {
      e.preventDefault();
      const src = media.src || media.getAttribute('src');
      if (src) {
        window.open(src, '_blank');
      }
    });
  });

  // Post-specific initialization
  if (document.querySelector('article#xerox-parc')) {
    createComputerClassGraph(document.querySelector('#computer-class-graph > div'));
  }
});
